import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {
  fetchGroupListAction, fetchOrderEdit,
  fetchOrderLeaveStudent,
  fetchOrderView
} from "../../../store/pages/admission/actions";
import {useParams, useSearchParams} from "react-router-dom";
import {selectStore} from "../../../store/selector";
import {UserLeaveNote} from "../../../components/pages/UserOrder/leave/UserLeaveNote";
import {Button, Col, Form, message, Row} from "antd";
import {useTranslation} from "react-i18next";
import dayjs from "dayjs";

const SEARCH_PARAMS = {
  TYPE: 'type',
  STUDENT_ID: 'student_id',
  GROUP_ID: 'group_id',
  FIO: 'fio',
  USER_ORDER_ID: 'user_order_id',
  MIN_DATE: 'min_date',
}

type IType = 'edit' | 'view' | 'create' | null | string

const FORM_NAME = {
  user: 'user',
  group: 'group',
  admin: 'admin',
  subadmin: 'subadmin',
}

export const LeaveUserOrder = () => {
  const {t} = useTranslation("common")


  const {id} = useParams()
  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch()

  const [form] = Form.useForm()

  const [order, setOrder] = useState()

  const type: IType = searchParams.get(SEARCH_PARAMS.TYPE);

  const studentId: string | null = searchParams.get(SEARCH_PARAMS.STUDENT_ID);
  const groupId: string | null = searchParams.get(SEARCH_PARAMS.GROUP_ID);
  const fio: any = searchParams.get(SEARCH_PARAMS.FIO)?.split('_')?.join(' ');
  const userOrderId: string | null = searchParams.get(SEARCH_PARAMS.USER_ORDER_ID);
  const minDate: string | null = searchParams.get(SEARCH_PARAMS.MIN_DATE);

  const {
    admission: {
      userOrder: userOrderState,
      groupList: groupListState,
    }
  } = useSelector(selectStore)

  useEffect(() => {
    if(type === 'view' || type === 'edit'){
      dispatch(fetchOrderView(userOrderId))
    }

    dispatch(fetchGroupListAction())
  }, []);

  useEffect(() => {
    if(userOrderState.data){
      let body = {
        number: userOrderState?.data?.number,
        date: dayjs(userOrderState?.data?.date),
        basis_ru: userOrderState?.data?.basis?.ru,
        basis_kk: userOrderState?.data?.basis?.kk,
      }

      setOrder((prevState: any) => ({
        ...prevState,
        ...body
      }))
      form.setFieldsValue(body)
    }
  }, [userOrderState.data]);

  useEffect(() => {
    if(groupListState.data){
      let currentGroupId = userOrderState?.data?.variables?.group_id || groupId

      let body = {
        user: {
          id: userOrderState?.data?.user?.id || studentId,
          label: userOrderState?.data?.user?.fio || fio,
        },

        group: {
          id: currentGroupId,
          label: groupListState.data?.groupsReception?.find((item: any) => item?.id == currentGroupId)?.caption,
        },

        admin: {
          id: groupListState.data?.reception?.director?.id,
          label: groupListState.data?.reception?.director?.fio,
        },

        subadmin: {
          id: userOrderState?.data?.variables?.sub_admin_id,
          label: groupListState.data?.reception?.teachers?.find((item: any) => item?.id == userOrderState?.data?.variables?.sub_admin_id)?.fio,
        },
      }
      setOrder((prevState: any) => ({
        ...prevState,
        ...body
      }))

      form.setFieldsValue(body)
    }
  }, [groupListState.data]);

  const handleSave = () => {
    form.validateFields().then((values) => {
      let body = {
        id: userOrderId,
        student_id: values.user.id,
        number: values.number,
        basis_ru: values.basis_ru,
        basis_kz: values.basis_kk,
        admin_id: values.admin.id,
        sub_admin_id: values.subadmin.id,
        date: dayjs(values.date).format('YYYY-MM-DD'),
      }

      if(type === 'create'){
        dispatch(fetchOrderLeaveStudent(body))
      } else {
        dispatch(fetchOrderEdit(body))
      }
    }).catch(() => {
      message.error(t("error"))
    })
  }

  return (
    <Row justify='center' style={{marginTop: 24, backgroundColor: '#fff'}}>
      <Col span={20}>
        <Row>
          <Col span={24}>
            <Form form={form} disabled={type === 'view'}>
              <Row style={{padding: 24}} justify='center'>
                <Form.Item name={FORM_NAME.user} hidden/>
                <Form.Item name={FORM_NAME.subadmin} hidden/>
                <Form.Item name={FORM_NAME.admin} hidden/>
                <Form.Item name={FORM_NAME.group} hidden/>
                <Col span={24}>
                  <UserLeaveNote
                    form={form}
                    order={order}
                    lang="ru"
                  />
                </Col>

                <Col span={24}>
                  <UserLeaveNote
                    form={form}
                    order={order}
                    lang="kz"
                  />
                </Col>

                {
                  (type === 'edit' || type === 'create') &&
                  <Col style={{padding: 10}}>
                    <Button
                      onClick={() => handleSave()}
                      type='primary'
                    >
                      {t('save')}
                    </Button>
                  </Col>
                }
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}